import { Component } from 'react'
import { API } from 'aws-amplify'
import moment from 'moment'
import QRCode from 'qrcode.react'
import withRouter from '../components/withRouter'
import SmallCard from '../components/smallCard'
import Logo from '../images/GigLoca_Logo_Light.png'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import { MdOutlineVerified } from 'react-icons/md'
import { GoUnverified } from 'react-icons/go'
import './node.css'

class Calendars extends Component {
    constructor(props) {
        super(props)

        this.state = {
            id: null,
            start: moment().date(1).format('YYYY-MM-DD'),
            stop: moment().date(1).add(1, 'month').format('YYYY-MM-DD'),
            selDay: null,
            displayMsg: false,
            msg: '',
            days: [],
            data: null,
            month: moment().date(1),
            css: null
        }

        this.handleEventSelect = this.handleEventSelect.bind(this)
    }

    componentDidMount() {
        const { path, search } = this.props
        const id = path.id || null
        if (id) {
            const queryParams = new URLSearchParams(search.search)
            const css = queryParams.get('color') || null
            let month = this.state.month
            let start = moment(month).subtract(month.day(), 'days').format('YYYY-MM-DD')
            let stop = moment(month).date(44 - (month.day() + moment(month).add(1, 'month').date()), 'days').format('YYYY-MM-DD')
            this.setState({ id, start, stop, css })
            this.getData(id, start, stop)
        }
    }

    handleMonthChanged(dir) {
        let month = moment(this.state.month)
        if (dir === 'back') {
            month.subtract(1, 'month')
        } else if (dir === 'next') {
            month.add(1, 'month')
        }
        let start = moment(month).subtract(month.day(), 'days').format('YYYY-MM-DD')
        let stop = moment(month).date(44 - (month.day() + moment(month).add(1, 'month').date()), 'days').format('YYYY-MM-DD')
        this.setState({ month, start, stop, selDay: null })
        this.getData(this.state.id, start, stop)
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false })
    }

    handleEventSelect(eid) {
        //this.handleNavigate(`event/${eid}`)
        window.open(`https://gigloca.com/event/${eid}`, '_blank', 'noopener')
    }

    handleCellSelect(selDay) {
        this.setState({ selDay })
    }

    handleQRClick() {
        window.open(this.state.id ? `https://gigloca.com/venue/${this.state.id}` : 'https://gigloca.com', '_blank', 'noopener')
    }

    getData(id, start, stop) {
        const headers = { Authorization: `Basic VSQzcm5hbWU6UGEkc3dvcmQ=` }
        API.get('lt', `userstuff?nid=${id}&start=${start}&end=${stop}`, { headers })
            .then(resp => {
                if (resp.data[0]) {
                    let days = []
                    const events = resp.data[0].events || []
                    events.sort((a, b) => {
                        if (a.startTime && b.startTime) {
                            if (moment(a.startTime).isBefore(moment(b.startTime))) return -1
                            if (moment(a.startTime).isAfter(moment(b.startTime))) return 1
                            return 0
                        } else return -1
                    }).forEach(e => {
                        if (e.startTime && e.stopTime) {
                            for (let x = moment(e.startTime).date(); x <= moment(e.stopTime).date(); x++) {
                                days.push(x)
                            }
                        }
                    })
                    this.setState({ data: { ...resp.data[0] }, id, days })
                }
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) this.handleNavigate('main')
            })
    }

    getMessage() {
        return <div className='Node-Confirm'>
            <div className='Node-Row Confirm-Text'>{this.state.msg}</div>
            <div className="Node-Row Node-Flex-Wrap">
                <div className='Pref-Button Pref-Button-Save' onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getCal() {
        let month = this.state.month
        let one = month.day()
        let dates = []
        let days = []
        for (let i = 0; i < one; i++) {
            let tmp = moment(month)
            tmp.subtract(one - i, 'days')
            days.push(tmp.date())
            dates.push(tmp.format('YYYY-MM-DD'))
        }
        let last = days.length
        let tmp = moment(month).add(1, 'month').subtract(1, 'day').date()
        for (let i = 1; i <= tmp; i++) {
            days.push(i)
            dates.push(moment(month).date(i).format('YYYY-MM-DD'))
        }
        let next = days.length
        let rem = 42 - days.length
        for (let i = 1; i <= rem; i++) {
            days.push(i)
            dates.push(moment(month).add(1, 'month').date(i).format('YYYY-MM-DD'))
        }
        return <div className='Calendar-Frame'>
            <div className='Calendar-Weekday-Header Node-Flex'>
                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d, didx) => {
                    return <div key={`wd-${didx}`} className={`Calendar-Cell Calendar-Cell-Top-Wall${didx === 0 ? ' Calendar-Cell-Left-Wall Calendar-Cell-Top-Left' : ''}${didx === 6 ? ' Calendar-Cell-Right-Wall Calendar-Cell-Top-Right' : ''}`} onClick={() => this.handleCellSelect(null)}>{d}</div>
                })}
            </div>
            <div className='Node-Flex-Wrap'>
                {
                    days.map((day, didx) => {
                        return <div key={`day-${didx}`} style={{ color: `${this.state.css && this.state.css.toLowerCase() === 'black' ? '#fff' : '#000'}` }} className={`Calendar-Cell${didx % 7 === 0 ? ' Calendar-Cell-Left-Wall' : ''}${didx % 7 === 6 ? ' Calendar-Cell-Right-Wall' : ''}${didx > 34 ? ' Calendar-Cell-Bottom-Wall' : ''}${didx === 35 ? ' Calendar-Cell-Bottom-Left' : ''}${didx === 41 ? ' Calendar-Cell-Bottom-Right' : ''}${this.state.selDay && moment(this.state.selDay).isSame(moment(dates[didx])) ? ' Calendar-Cell-On' : ''}`} onClick={() => this.handleCellSelect(dates[didx])}>
                            <div style={{ fontWeight: 'bold' }} className={`Calendar-xRow Node-Flex-Right${didx >= next ? ' Calendar-Cell-Off' : ''}${didx < last ? ' Calendar-Cell-Off' : ''}`}>{day}</div>
                            {
                                this.state.data.events ? this.state.data.events.filter(e => moment(e.startTime).isBetween(moment(dates[didx]), moment(dates[didx]).add(1, 'day'))).map((e, eidx) => {
                                    return <div key={`e-${eidx}`} className='Calendar-xRow'>
                                        <div className='Calendar-xRow-Text'><span className={`Calendar-Verified`}>{e.active ? <MdOutlineVerified /> : <GoUnverified />}</span>{e.title}</div>
                                    </div>
                                }) : null
                            }

                        </div>
                    })
                }
            </div>
        </div>
    }

    render() {
        console.log(this.state)
        return this.state.data ? <div className={`Calendars-Container`}>
            <div className={`Calendar-xContainer${this.state.css ? ` Calendar-${this.state.css.toLowerCase()}` : ''}`}>
                <div className='Node-Row'>
                    <div>
                        <div className='Node-Row Node-Flex-Wrap Calendar-xHeader'>
                            <div className='Calendar-xButton' onClick={() => this.handleMonthChanged('back')}><FaArrowCircleLeft /></div>
                            <div>{this.state.month.format('MMMM YYYY')}</div>
                            <div className='Calendar-xButton' onClick={() => this.handleMonthChanged('next')}><FaArrowCircleRight /></div>
                        </div>
                        {this.getCal()}
                    </div>
                </div>
                <div className='Node-Row'>
                    {this.state.selDay ? this.state.data.events && this.state.data.events.filter(e => moment(e.startTime).isBetween(moment(this.state.selDay), moment(this.state.selDay).add(1, 'day'))).length > 0 && <div className='Node-Row Node-Flex-Left'>
                        <div style={{ color: '#fff' }} className='Node-Divider-Text'>{moment(this.state.selDay).format('ll')}</div>
                        <div className='Node-Divider'></div>
                    </div> : null}
                    {this.state.selDay && this.state.data.events && this.state.data.events.filter(e => moment(e.startTime).isBetween(moment(this.state.selDay), moment(this.state.selDay).add(1, 'day'))).length > 0 && <div className='Node-Row Node-Flex-Wrap'>{this.state.data.events.filter(e => moment(e.startTime).isBetween(moment(this.state.selDay), moment(this.state.selDay).add(1, 'day'))).map((event, eidx) => {
                        return <SmallCard key={`ue-${eidx}`} type='event' data={event} onSelect={this.handleEventSelect} />
                    })}</div>}
                    {this.state.data.events ? this.state.data.events.filter(e => moment(e.stopTime).isAfter(moment())).length > 0 && <div className='Node-Row Node-Flex-Left'>
                        <div style={{ color: '#fff' }} className='Node-Divider-Text'>Upcoming & Current Events</div>
                        <div className='Node-Divider'></div>
                    </div> : null}
                    {this.state.data.events && this.state.data.events.filter(e => moment(e.stopTime).isAfter(moment())).length > 0 && <div className='Node-Row Node-Flex-Wrap'>{this.state.data.events.filter(e => moment(e.stopTime).isAfter(moment())).map((event, eidx) => {
                        return <SmallCard key={`ue-${eidx}`} type='event' data={event} onSelect={this.handleEventSelect} />
                    })}</div>}
                    {this.state.data.events && this.state.data.events.filter(e => moment(e.stopTime).isBefore(moment())).length > 0 && <div className='Node-Row Node-Flex-Left'>
                        <div style={{ color: '#fff' }} className='Node-Divider-Text'>Past Events</div>
                        <div className='Node-Divider'></div>
                    </div>}
                    {this.state.data.events && this.state.data.events.filter(e => moment(e.stopTime).isBefore(moment())).length > 0 && <div className='Node-Row Node-Flex-Wrap'>{this.state.data.events.filter(e => moment(e.stopTime).isBefore(moment())).map((event, eidx) => {
                        return <SmallCard key={`ue-${eidx}`} type='event' data={event} onSelect={this.handleEventSelect} />
                    })}</div>}
                    {this.state.id && <div className='Node-Row Node-Flex-Wrap'><div style={{ cursor: 'pointer' }} onClick={() => { this.handleQRClick() }}><QRCode value={`https://gigloca.com/venue/${this.state.id}`} /></div></div>}
                </div>
            </div>
        </div> : <div style={{ padding: '10%' }} className='Empty-Container Node-Black'><img className='Node-Logo' src={Logo} alt="GigLoca" /></div>
    }
}

export default withRouter(Calendars)